<template>
  <v-container class="A4 mb-3" id="printMe">
    <v-row class="d-flex justify-end my-header">
      <v-btn @click="goBack" class="primary my-btn my-1">
        <i class="mdi mdi-arrow-left-bold"></i>返回
      </v-btn>
      <v-btn v-print="printObj" class="primary my-btn my-1 ml-1 mr-11">
        <i class="mdi mdi-printer"></i>打印
      </v-btn>
    </v-row>
    <h1 class="head-1">
      嘉善县魏塘街道贴息奖励计算表
    </h1>
    <table border="1" bordercolor="#000000">
      <tr>
        <td colspan="2" class="head-2">姓名</td>
        <td colspan="3" class="input-text1" >
          {{ details.customer }}
        </td>
        <td colspan="2" class="head-2 six_word">签订时间</td>
        <td colspan="2" class="input-text1">{{
                  $moment(details.start_date)
                    .utc()
                    .format("YYYY-MM-DD")
                }}</td>
        <td colspan="2" class="head-2 six_word">申请时间</td>
        <td colspan="2" class="input-text1">{{
                  $moment(details.end_date)
                    .utc()
                    .format("YYYY-MM-DD")
                }}</td>

      </tr>
      <tr>
        <td colspan="2" class="head-2">补偿款</td>
        <td colspan="2" class="input-text">{{ details.total_fee }}</td>
        
        <td class="input-text12">元</td>
        <td colspan="8" class="input-text"></td>
      </tr>
      <tr>
        <td colspan="2" class="head-2">贴息奖励/年</td>
        <td colspan="2" class="input-text">{{ details.rate }}%</td>
        
        <td ></td>
        <td colspan="8" class="input-text"></td>
      </tr>
      <tr><td colspan="13"></td></tr>
      <tr>
        <td colspan="2" class="input-text12">包首日和尾日</td>
        <td colspan="2" class="head-3">{{ details.total_fee }}</td>
        
        <td class="head-3">×</td>
        <td class="head-3">{{ details.rate }}%</td>
        <td class="head-3">÷</td>
        <td class="head-3">{{ details.days}}</td>
        <td class="head-3">×</td>
        <td class="head-3">{{ details.day}}</td>
        <td class="head-3">＝</td>
        <td colspan="2" class="head-3">{{ details.interest_fee}}</td>
      </tr>
      <tr><td colspan="13"></td></tr>
      <tr><td colspan="13" class="input-text2">年月天数参照表</td></tr>
      <tr>
        <td class="head-2">年\月</td>
        <td class="head-2">1</td>
        <td class="head-2">2</td>
        <td class="head-2">3</td>
        <td class="head-2">4</td>
        <td class="head-2">5</td>
        <td class="head-2">6</td>
        <td class="head-2">7</td>
        <td class="head-2">8</td>
        <td class="head-2">9</td>
        <td class="head-2">10</td>
        <td class="head-2">11</td>
        <td class="head-2">12</td>
      </tr>
      <tr>
        <td class="head-2">2019</td>
        <td class="head-4">31</td>
        <td class="head-4">28</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
      </tr>
       <tr>
        <td class="head-2">2020</td>
        <td class="head-4">31</td>
        <td class="head-4">29</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
      </tr>
       <tr>
        <td class="head-2">2021</td>
        <td class="head-4">31</td>
        <td class="head-4">28</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
      </tr>
       <tr>
        <td class="head-2">2022</td>
        <td class="head-4">31</td>
        <td class="head-4">28</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
      </tr>
       <tr>
        <td class="head-2">2023</td>
        <td class="head-4">31</td>
        <td class="head-4">28</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
      </tr>
       <tr>
        <td class="head-2">2024</td>
        <td class="head-4">31</td>
        <td class="head-4">29</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
        <td class="head-4">30</td>
        <td class="head-4">31</td>
      </tr>
      
    </table>

    <v-row class="d-flex justify-space-between note-footer">
      <span
        >领款人签字：
        <!-- :value="user_name" -->
        <input
          type="text"
          name="name"
          style="border:none;border-bottom:1.5px solid #555555;"
          class="my-input"
        />
      </span>
      <span
        >银行账号：
        <input
          type="text"
          name="name"
          style="border:none;border-bottom:1.5px solid #555555;"
          class="my-input"
        />
      </span>
    
    </v-row>
    <!-- <v-row>
        <v-col>
          <span style="padding-left:30px">注：以上内容面积单位为平方米(㎡)</span>
        </v-col>
      </v-row> -->
  </v-container>
</template>

<script>
import { fetchBill } from "@/api/bills";
import { fetchInterest } from "@/api/interest";

export default {
  name: "Bill Print",
  components: {},

  filters: {},
  data() {
    return {
      seq: "",
      user_name: this.$store.getters.name,
      company: this.$store.getters.company,
      details: null,
      // population_price: 580,
      // property_price: 960,
      // extend20_price: 3510,
      // market_discount_price: 6110,
      // market_price: 6110,
      dt_now: "",
      printObj: {
        id: "printMe",
        popTitle: "good print",
        extraCss: "https://www.baidu.com",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>'
      },
      cssBackgroundImg: {
        backgroundImage: `url(${require("@/assets/background.jpg")})`
      }
    };
  },

  computed: {
    isAdminRole() {
      if (this.$store.getters.roles.includes("admin")) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.getInterest(this.$route.params.id);
    this.dt_now = Date.now();
    this.seq = this.$route.params.seq;
  },

  methods: {
    goBack() {
      console.log("goback clicked");
      this.$router.go(-1);
    },
    getInterest(id) {
      this.listLoading = true;
      fetchInterest(id).then(response => {
        this.details = response.data;
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    }
  }
};
</script>

<style scoped>
body {
  margin: auto;
  padding: auto;
  background: rgb(65, 63, 63);
}
.A4 {
  background: rgb(180, 180, 180);
  /* width: 21cm;
  height: 29.7cm; */
  width: 1122px;
  height: 794px;
  display: block;
  /* box-shadow: 0 0 1px 1px rgb(2, 164, 252); */
  overflow-y: auto;
  box-sizing: border-box;
  margin: auto;
}

.head-1 {
  margin-top: 0;
  padding: 0 0 20px 0;
  font-weight: 800;
  font-size: 21pt;
  text-align: center;
}

.head-2 {
  padding: 2pt;
  font-weight: 600;
  font-size: 12pt !important;
  text-align: center;
  background-color: rgb(136, 134, 132);
}

.head-3 {
  font-weight: 400;
  font-size: 12pt !important;
  color: white;
  text-align: center;
  background-color: rgb(249, 182, 0);
}

.head-4 {
  font-weight: 400;
  font-size: 11pt !important;
  text-align: center;
  background-color: rgb(59, 71, 230);
}

.input-text {
  font-weight: 600;
  font-size: 10pt;
  color: rgb(0, 0, 0);
}
.input-text1 {
  font-weight: 600;
  font-size: 10pt;
  color: rgb(0, 0, 0);
  text-align: center;
}
.input-text12 {
  font-weight: 600;
  font-size: 12pt;
  color: rgb(0, 0, 0);
  text-align: center;
}
.input-text2 {
  font-weight: 600;
  font-size: 12pt;
  color: rgb(0, 0, 0);
  text-align: left;
}

.input-text-red {
  font-weight: 700;
  font-size: 10pt;
  color: rgb(231, 5, 5);
}

.money {
  text-align: left;
  font-weight: 600;
  color: rgb(3, 54, 192);
  padding: 0 0 0 20px;
}

td {
  padding-top: 9px;
  padding-bottom: 6px;
  padding-left: 8px;
  padding-right: 8px;
}

table {
  margin: auto;
  text-align: right;
  width: 90%;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  justify-content: space-around;
}

.note-header {
  padding: 0px 30px 15px 40px;
}

.note-footer {
  padding: 20px 25px 10px 100px;
  width: 90%;
}

.my-input-header {
  margin: 0 500px 0 0;
  border: none;
  border-bottom: 1.5px solid #555555;
  width: 230px;
}

.my-input {
  margin: 0 35px 0 0;
}

.sanjiaoxing {
  width: 0;
  height: 0;
  border-color: transparent rgb(231, 93, 93);
  border-width: 0 0 120px 120px;
  border-style: solid;
  position: absolute;
}

.sequence {
  margin: 0 0 5px 10px;
  padding: 0 5px 0 5px;
  position: absolute;
  /* background-color: rgb(172, 104, 104); */
  transform: rotate(-45deg);
  transform-origin: 20% 40%;
}



@page {
  /* size: A4; */
  size: landscape;
  margin: 0;
}

/* @media print{@page {size: landscape}} */

@media print {
  .A4 {
    background: white;
  }

  .head-2 {
    background-color: rgb(231, 229, 226);
  }

  .head-4 {
    background-color: rgb(231, 229, 226);
  }

  .my-header {
    height: 50px;
  }
  .my-btn {
    display: none;
  }

  .six_word {
    width: 120px;
  }

  .sanjiaoxing {
    display: none;
  }

  .sequence {
    display: none;
  }
}
</style>
